<!--

Apply Branding(s) to all currently displayed OverlayDataField widgets.

Depends on Brandings being fetched beforehand.

-->
<template>
  <v-menu
    offset-y
    :disabled="!hasBrandings"
    :class="{'no-cursor-pointer-on-activator': !hasBrandings}"
    :title="$t('templateDataApplyBranding')"
  >
    <v-btn
      slot="activator"
      flat
      round
      class="mx-0"
      color="msr"
      :disabled="!hasBrandings"
      :title="$t('tvtemplatesPreviewApplyBranding')"
    >
      <v-icon left>
        format_paint
      </v-icon>
      {{ title || $t('tvtemplatesPreviewApplyBranding') }}
      <v-icon right>
        arrow_drop_down
      </v-icon>
    </v-btn>
    <v-list>
      <template v-for="branding in brandings">
        <v-hover :key="'hover-' + branding.id">
          <v-list-tile
            :key="'tile-' + branding.id"
            slot-scope="{hover}"
            :disabled="!hasBrandings"
            @click="applyBrandingToAllTvTemplates(branding)"
          >
            <v-list-tile-content :title="$t('templateDataApplyBranding')">
              <v-list-tile-title
                :class="{
                  'msr--text font-weight-bold':
                    lastBrandingApplied &&
                    lastBrandingApplied.id == branding.id,
                }"
              >
                {{ branding.name }}
              </v-list-tile-title>
              <v-list-tile-sub-title
                v-if="branding.is_default"
                class="msr--text caption"
              >
                {{ $t('brandingIsDefault') }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action :title="$t('brandingDialogTitleEdit')">
              <v-btn
                v-if="hover"
                icon
                color="msr--text"
                :to="{name: 'branding', query: {edit: branding.id}}"
                @click.stop
              >
                <v-icon> edit </v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-hover>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import tvtemplateBrandings from '@/mixins/tvtemplateBrandings.js';

export default {
  mixins: [tvtemplateBrandings],
  props: {
    tvtemplates: {
      type: Array[Object],
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
  },
  computed: {
    lastBrandingApplied() {
      return this.$store.state.common.lastBrandingApplied;
    },
  },
  methods: {
    applyBrandingToAllTvTemplates(branding) {
      for (const tvtemplate of this.tvtemplates) {
        const changeset = this.getChangesetToApplyBranding(
          branding,
          tvtemplate.overlay_options
        );
        this.$emit('apply-branding', {
          branding: branding,
          tvtemplate: tvtemplate,
          changeset: changeset,
        });
      }

      this.$emit('applied');
    },
  },
};
</script>

<style scoped>
.no-cursor-pointer-on-activator >>> .v-menu__activator {
  cursor: default !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AllTvTemplatesBrandingWidget.vue